import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3054c282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "praise-modal__compose" }
const _hoisted_2 = {
  key: 0,
  class: "select-response-message"
}
const _hoisted_3 = { class: "praise-modal__text-input" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = ["textContent"]

import { computed } from 'vue'
import AtTa from 'vue-at/dist/vue-at-textarea'
import Textarea from 'primevue/textarea'
import PraiseModalResponseCarousel from '@/components/FrontlineManagerDash/PraiseModal/PraiseModalResponseCarousel.vue'
import { ActionResponse, TeamMember } from '@/entities/frontlineManagerDash'

interface Props {
    responses: ActionResponse[]
    teamMembers: TeamMember[]
    tags: string[]
    inputPlaceholder: string
    showCarouselIndicators: boolean
    isMobile?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StepCompose',
  props: /*#__PURE__*/_mergeModels({
    responses: {},
    teamMembers: {},
    tags: {},
    inputPlaceholder: {},
    showCarouselIndicators: { type: Boolean, default: true },
    isMobile: { type: Boolean, default: false }
  }, {
    "textInput": {
    default: '',
    type: String,
},
    "textInputModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['responseChanged'], ["update:textInput"]),
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const textInput = _useModel(__props, 'textInput')

const onPraiseChange = (response: ActionResponse) => {
    emit('responseChanged', response)
}

const members = computed(() => {
    const validTeamMembers =
        props.teamMembers?.filter((member) => member?.name) ?? []
    const validTags = props.tags?.map((tag) => ({ name: tag, email: '' })) ?? []

    return [...validTeamMembers, ...validTags].sort((a, b) =>
        a.name.localeCompare(b.name)
    )
})

const atFilterMatch = (name, chunk, at) => {
    if (!name || !at) {
        return false
    }

    const isNameMatchingChunk =
        name?.toLowerCase()?.indexOf(chunk?.toLowerCase() ?? '') === 0
    const isMentionMatch =
        at === '@' &&
        props.teamMembers.length &&
        props.teamMembers.some((mention) => mention.name === name)
    const isTagMatch = at === '#' && props.tags.includes(name)

    return isNameMatchingChunk && (isMentionMatch || isTagMatch)
}

const atDeleteMatch = (name, chunk, suffix) => {
    if (!name || !chunk || !suffix) {
        return false
    }

    return chunk === name + suffix
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.responses.length > 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Select response to highlight "))
      : _createCommentVNode("", true),
    _createVNode(PraiseModalResponseCarousel, {
      responses: _ctx.responses,
      "is-mobile": _ctx.isMobile,
      "show-carousel-indicators": _ctx.showCarouselIndicators,
      onPraiseChange: onPraiseChange
    }, null, 8, ["responses", "is-mobile", "show-carousel-indicators"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(AtTa), {
        members: members.value,
        "name-key": "name",
        ats: ['@', '#'],
        "filter-match": atFilterMatch,
        "delete-match": atDeleteMatch
      }, {
        item: _withCtx((scope) => [
          _createElementVNode("span", {
            class: "name",
            "data-testid": "fm-dash-at-name",
            textContent: _toDisplayString(scope.item.name)
          }, null, 8, _hoisted_4),
          _createElementVNode("span", {
            class: "email",
            textContent: _toDisplayString(
                            scope.item.email !== undefined
                                ? scope.item.email
                                : scope.item.description
                        )
          }, null, 8, _hoisted_5)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Textarea), {
            modelValue: textInput.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textInput).value = $event)),
            class: "praise-modal__text-input__text-area",
            rows: "5",
            size: "large",
            placeholder: _ctx.inputPlaceholder
          }, null, 8, ["modelValue", "placeholder"])
        ], undefined, true),
        _: 1
      }, 8, ["members"])
    ])
  ]))
}
}

})